// extracted by mini-css-extract-plugin
export var breadcrumb = "_9-0";
export var breadcrumbArrow = "_9-1";